'use es6';

import { Component } from 'react';
import { DragSource } from 'react-dnd-compat';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultData = () => ({});
export default function (itemType, data) {
  if (data == null) {
    data = defaultData;
  }
  const ITEM_SOURCE = {
    beginDrag(props) {
      return {
        index: props.index || -1,
        originalIndex: props.index,
        data: data(props)
      };
    },
    endDrag(props, monitor) {
      const didDrop = monitor.didDrop();
      if (didDrop) {
        props.onDrop();
      } else {
        props.onReset();
      }
    }
  };
  return WrappedComponent => {
    const componentName = WrappedComponent.displayName || WrappedComponent.name;

    // As a precaution, use a a class component instead of a functional component
    // so that it can be located using `findDOMNode`. Functional components can not
    // be located via `findDOMNode`.
    //
    // Though we aren't using findDOMNode directly in this file, for consistency
    // with `DnDListWrapper` (which does), and to avoid any accidental breakage
    // in react-dnd (which might), use a findable class component.
    //
    // See https://reactjs.org/docs/strict-mode.html#warning-about-deprecated-finddomnode-usage
    // See https://github.com/reactjs/rfcs/pull/97
    class DnDListDragSourceWrapper extends Component {
      render() {
        return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
      }
    }
    DnDListDragSourceWrapper.displayName = `DnDListDragSourceWrapper(${componentName})`;
    return DragSource(itemType, ITEM_SOURCE, monitor => ({
      isDragging: monitor.isDragging()
    }))(DnDListDragSourceWrapper);
  };
}